module.exports = __webpack_public_path__ + "img/DSC_0106.8d8c96b5.jpg";